import { z } from "zod";


export const DomainFormSchema = z.object({
    Name: z.string(),
    Website: z.string().url(),
    Folder: z.string(),
    Admin: z.string(),
    CompanyID: z.string(),
    OwnerEmail: z.string().email(),
    Version: z.string(),
    Key: z.string(),
    DBRel: z.string(),
    DBServer: z.string(),
    DBName: z.string(),
    DBUser: z.string(),
    DBPassword: z.string(),
    Package: z.string(),
    PaymentPackage: z.string(),
})